export enum ReferralFormSections {
    REFERRAL = 'referral',
    PRIMARY_PATIENT = 'primaryPatient',
    ATTACHMENTS = 'attachments',
    REFERRAL_ATTACHMENTS = 'referralAttachments',
    ADDED_ATTACHMENTS = 'addedAttachments',
    REMOVED_ATTACHMENTS = 'removedAttachments',
    OTHER_PATIENTS = 'otherPatients',
}
